import React from 'react';

import { css, cx } from '@emotion/css';
import { CardHeader, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { Message } from '@/models/MessagingModel.ts';
import { userFormattedName } from '@/models/UserModel.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { toDateTime } from '@/utils/dateUtils.ts';

export type MessageTitleProps = {
  message: Message;
  className?: string;
  userIsSender: boolean;
};

export const MessageTitle: React.FC<MessageTitleProps> = ({
  message,
  userIsSender,
  className,
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  const timeSent = toDateTime(message.createdAt).toLocaleString(
    DateTime.TIME_SIMPLE,
  );

  const senderName = userIsSender
    ? t('messaging.me')
    : userFormattedName(message.firstname, message.lastname);

  return (
    <CardHeader
      className={cx(styles.container, className)}
      title={
        <>
          <Typography className={styles.title}>{senderName}</Typography>
          <Typography variant="caption">{timeSent}</Typography>
        </>
      }
    />
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    padding: 0,
  }),
  title: css({
    fontWeight: 'bold',
    marginRight: theme.spacing(4),
  }),
  unreadTitle: css({
    fontStyle: 'italic',
  }),
});
